import React, { useContext, useState } from 'react';

import { InfoOutlined } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Alert, Box, Button, Typography } from '@mui/material';
import dayjs from 'dayjs';

import ReservationContext from '../../providers/ReservationContext';
import { longSentenceFormat } from '../../utils/datetime/formatDate';
import { standardTimeFormat } from '../../utils/datetime/formatTime';
import Divider from '../shared/Divider';
import Locations from '../shared/Locations';

const ReservationDetailsTab = () => {
  const { orderV2Data, permissions } = useContext(ReservationContext);
  const [open, setOpen] = useState(false);

  const ServiceDates = () =>
    orderV2Data?.jobs?.map((job, i, { length }) => (
      <Typography key={job.id} sx={{ pb: length - 1 === i ? 2 : 0, color: (theme) => theme.palette.neutral.medium }}>
        {`${longSentenceFormat(dayjs(job.start_date_time).unix())} starting ${standardTimeFormat({
          datetime: dayjs(job.start_date_time).unix(),
          zone: job.start_timezone,
          createdDate: dayjs(orderV2Data?.created_at).unix(),
        })}`}
      </Typography>
    ));

  return (
    <Box sx={{ display: { xs: 'block', md: 'none' } }}>
      <Accordion
        expanded={open}
        onChange={() => setOpen(!open)}
        sx={{
          display: 'flex',
          width: '100%',
          mx: 'auto',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          '&:first-of-type': {
            borderBottomLeftRadius: 24,
            borderBottomRightRadius: 24,
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
          },
        }}
      >
        <AccordionSummary aria-controls='panel1a-content' id='panel1a-header'>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant='h3'>Order: {orderV2Data.confirmation_id}</Typography>
            <ServiceDates />
            {open ? (
              <Divider />
            ) : (
              <Button sx={{ height: 10 }} onClick={() => setOpen(true)}>
                See more
              </Button>
            )}
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              mt: -2,
            }}
          >
            <Locations locations={orderV2Data?.locations} />
            <Box pt={3}>
              <Button variant='outlined' href='/details'>
                See full details
              </Button>
              <Button onClick={() => setOpen(false)}>See less</Button>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
      {permissions?.showNonGuaranteed ? (
        <Box pt={2} px={1}>
          <Alert severity='success' icon={<InfoOutlined />}>
            Rushed Booking Request: We successfully assemble a team 95% of the time and will contact you with status updates.
          </Alert>
        </Box>
      ) : null}
    </Box>
  );
};

export default ReservationDetailsTab;
